export class ReportRequestDTO {
  public InvNumber: string;
  public InvFileName: string;
  public RctNumber: string;
  public LID: string;
  public PONumber: string;
  public StmtFileName: string;
  public CreditNumber: string;
  public ContractNumber: string;
  public AssetType: string;
  public LstdtEdt: string;
  public Custnmbr: string;
  public ActionName: string;
  public ToEmail: string;
  public CCEmail: string;
  public Comments: string;
  public DocumentType: string;
  public reportID;string;
  public workSpaceID:string;

  constructor(InvNumber: string, CreditNumber: string, ToEmail: string, CCEmail: string, ActionName: string, Comments: string) {
    this.InvNumber = InvNumber;
    this.CreditNumber = CreditNumber;
    this.ToEmail = ToEmail;
    this.CCEmail = CCEmail;
    this.ActionName = ActionName;
    this.Comments = Comments;

  }

}



// WEBPACK FOOTER //
// ./src/app/models/ReportRequestDTO.ts